"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CustomModulePurposeOptions = _interopRequireDefault(require("../constants/CustomModulePurposeOptions"));

var _default = Object.keys(_CustomModulePurposeOptions.default).filter(function (tagKey) {
  return tagKey !== _CustomModulePurposeOptions.default.NONE;
});

exports.default = _default;
module.exports = exports.default;